import Api from "@/api/Api";
import errorHandler from "@/utils/plugins/ErrorHandler";

const RESOURCE_TRACKER = "/api/course_sessions";

export default {
  async getCoursesSession(params) {
    return await Api()
      .get(RESOURCE_TRACKER, { params: params })
      .catch((err) => errorHandler(err, null));
  },
  async createCourseSession(params) {
    return Api()
      .post(RESOURCE_TRACKER, params)
      .catch((err) => errorHandler(err, null));
  },
  async updateCourseSession(id, params) {
    return Api()
      .put(`${RESOURCE_TRACKER}/${id}`, params)
      .catch((err) => errorHandler(err, null));
  },
  async getCourseSession(id, params) {
    return Api()
      .get(`${RESOURCE_TRACKER}/${id}`, params)
      .catch((err) => errorHandler(err, null));
  },
  async discardCourseSession(id) {
    return Api()
      .delete(`${RESOURCE_TRACKER}/${id}`)
      .catch((err) => errorHandler(err, null));
  },
    async enrollToCourseSession(id, params) {
    return Api()
      .post(RESOURCE_TRACKER+'/'+id+'/enroll', params)
      .catch((err) => errorHandler(err, null));
  },
    async completeCourseSession(id, params) {
    return Api()
      .post(RESOURCE_TRACKER+'/'+id+'/complete_enrollment', params)
      .catch((err) => errorHandler(err, null));
  },
    async cancelCourseSession(id, params) {
    return Api()
      .post(RESOURCE_TRACKER+'/'+id+'/cancel_enrollment', params)
      .catch((err) => errorHandler(err, null));
  },
};
